import Select from "@mui/material/Select";
import { FlagIcon } from "react-flag-kit";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": { marginTop: theme.spacing(3) },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

export default function ChangeLanguageSelect({ onChange }) {
  const language = localStorage.getItem("i18nextLng");

  return (
    <FormControl sx={{ m: 1 }} variant="standard">
      <Select
        onChange={onChange}
        value={language || "en"}
        input={<BootstrapInput />}
        id="demo-customized-select"
        labelId="demo-customized-select-label"
      >
        <MenuItem value={"en"}>
          <FlagIcon size={25} code="US" />
        </MenuItem>
        <MenuItem value={"pt"}>
          <FlagIcon size={25} code="BR" />
        </MenuItem>
        <MenuItem value={"es"}>
          <FlagIcon size={25} code="ES" />
        </MenuItem>
        <MenuItem value={"fr"}>
          <FlagIcon size={25} code="FR" />
        </MenuItem>
      </Select>
    </FormControl>
  );
}
